import { Sheet, SheetContent } from '@nexus/ui';
import { useTranslation } from 'react-i18next';
import type { NavModule } from '../modules/navigation';
import { CompanySwitcher } from './company-switcher';
import { NavigationList } from './sidebar';

/**
 * The whole navigation on the phone, as on the desktop, in a sheet from the left. Radix keeps the
 * focus inside and closes it with Escape; choosing an entry closes it too.
 */
export function NavMenu({
  navigation,
  open,
  onOpenChange,
}: {
  navigation: readonly NavModule[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const { t } = useTranslation();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" title={t('shell.menu')}>
        <div className="-mx-3 flex flex-col gap-3">
          <div className="border-b border-line px-1.5 pb-3">
            <CompanySwitcher inMenu onSwitched={() => onOpenChange(false)} />
          </div>
          <NavigationList
            navigation={navigation}
            onNavigate={() => onOpenChange(false)}
            className="px-2"
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
